import { DEFAULT_EMPTY_VALUE_PLACEHOLDER } from 'configs/common';
import { ORDER_PAYMENT_TYPES_ICONS } from 'configs/orders';
import { IDispatcherOrder } from 'types/api';
import { IOrderCardData } from './types';

// ! cards data
const transformIDispatcherOrderToIOrderCardData = (order: IDispatcherOrder): IOrderCardData => {
	const { id, info, store: branch, payment, driver, products, delivery_address, timeline, actions } = order;
	return {
		vendorId: branch.vendor_id,
		// branch
		order_id: id,
		branch,
		pickup_address: branch.address.length ? branch.address : DEFAULT_EMPTY_VALUE_PLACEHOLDER,
		pickup_address_latlng: {
			lat: branch.lat,
			lng: branch.lng,
		},
		// info
		order_code: info.code,
		status: info.status,
		status_description: info.status_description,

		order_placed_at: info.placed_at,
		order_new_at: info.new_at,
		order_paid_at: payment.paid_at,
		order_type: info.type,

		order_list: products.order_product_list,
		delivery_status: info.delivery_status,
		booking_type: info.booking_type,
		pickup_time: info.pickup_time,
		delivery_mode: info.delivery_mode,
		delivery_mode_description: info.delivery_mode_description,
		delivery_mode_description_detailed: info.delivery_mode_description_detailed,
		min_customer_delivery_eta_at: info.min_customer_delivery_eta_at,
		max_customer_delivery_eta_at: info.max_customer_delivery_eta_at,

		// payment
		payment_status: payment.status,
		payment_type: payment.method,
		payment_type_icon: ORDER_PAYMENT_TYPES_ICONS[payment.method],
		payment_should_display_payment_method: payment.should_display_payment_method,
		to_pay: `${payment.amount_payable} ${payment.currency_code}`,
		total_order: `${payment.grand_total} ${payment.currency_code}`,

		// driver
		driver_id: driver?.id,
		driver_name: driver?.name,

		// delivery address
		delivery_address: delivery_address.address,
		delivery_address_latlng: {
			lat: delivery_address.lat,
			lng: delivery_address.lng,
		},

		// order timeline
		timeline,

		// order status actions
		actions,
	};
};

export const transformDataToCardData = (orders: IDispatcherOrder[]): IOrderCardData[] => {
	return orders.map(transformIDispatcherOrderToIOrderCardData);
};
